import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueSweetalert2 from 'vue-sweetalert2'
import router from './router/index'
import {store} from '@/store'
import vco from "v-click-outside"
import "@/design/index.scss";
import Sparkline from 'vue-sparklines';
import moment from 'moment'
import vSelect from 'vue-select'
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';
import { config} from "@/services/config";
const socket = io(config.$socket_url);
import CxltToastr from 'cxlt-vue2-toastr'
import JsonExcel from "vue-json-excel";

Vue.filter("currency",(value) => {
  return parseFloat(value).toLocaleString(undefined, {minimumFractionDigits : 2})
});
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
})
import "vue-select/dist/vue-select.css";
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'

Vue.use(BootstrapVue);
Vue.config.productionTip = false
Vue.use(CxltToastr)
Vue.use(VueSocketIOExt, socket);
Vue.use(Vuelidate);
Vue.use(VueMask)
Vue.use(VueSweetalert2)
Vue.use(require('vue-chartist'))
Vue.use(vco)
Vue.use(Sparkline)
Vue.component('v-select', vSelect)
Vue.component("downloadExcel", JsonExcel);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
